<template>
  <div :id="id" class="flex items-center justify-center"></div>
</template>
<script>
export default {
  name: "DfpSlot",

  props: {
    size: Array,
    path: String,
    id: String,
    medicalPractice: {
      type: String,
      default: null
    }
  },

  beforeCreate() {
    window.googletag &&
    window.googletag.cmd &&
    window.googletag.cmd.push(() => {
      window.googletag.destroySlots();
    });
  },

  mounted() {
    const { path, size, id } = this;

    const medicalPractice = this.medicalPractice
      ? this.medicalPractice
      : this.$store.state.patientMedicalPractice;
    medicalPractice &&
    window.googletag &&
    window.googletag.cmd &&
    window.googletag.cmd.push(() => {
      window.googletag
        .defineSlot(path, size, id)
        .addService(window.googletag.pubads())
        .setTargeting("platform", "web")
        .setTargeting("audience", "patient")
        .setTargeting("language", this.$store.state.frontLanguage)
        .setTargeting("practice", medicalPractice.toLowerCase());
      window.googletag.pubads().enableSingleRequest();
      window.googletag.pubads().collapseEmptyDivs();
      window.googletag.enableServices();
      window.googletag.display(id);
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DfpSlot.vue